import classNames from 'classnames/bind';
import AirlineLogo from 'common/airlineLogo';
import { IKeyStringValue } from 'common/types';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  avs: string[];
  airlines: IKeyStringValue;
  children?: JSX.Element | boolean;
}

export default function Airlines({ avs, airlines, children }: IProps) {
  return (
    <div className={cx('Airlines')}>
      <span className={cx('logos')} data-area="logos">
        {avs.map((av, i) => (
          <AirlineLogo
            key={`airlineVendors_${i}`}
            airlineCode={av}
            alt={airlines[av]}
            className={cx('logo')}
          />
        ))}
      </span>
      <span className={cx('text')} data-area="texts">
        <b className={cx('name')}>
          {avs.map((name, i) => airlines[name]).join(', ')}
        </b>
        {children && <span className={cx('info')}>{children}</span>}
      </span>
    </div>
  );
}
